import { request } from '@/utils/request'
// 此处写形成promise的请求

function getUserInfoByCode (code) {
  return request({
    url: '/0.1/wechat/pc/login?code=' + code,
    method: 'get'
  })
}
function getUserInfoById (id) {
  return request({
    url: '/0.3/user/' + id,
    method: 'get'
  })
}
export {getUserInfoByCode, getUserInfoById}



// WEBPACK FOOTER //
// ./src/api/authentication.js